import api from '../../api';
import { faLandmark } from '@fortawesome/free-solid-svg-icons';

export const PAGE_CONFIG = (tr) => ({
    BREADCRUMB: [
        { label: 'Home', link: '/' },
        { label: tr('pageTitle'), link: '/tanzania-constitution' }
    ],
    PAGE_TITLE: tr('pageTitle'),
    PAGE_DESCRIPTION: tr('pageDescription'),
    GET_QUERY_KEY: 'tanzaniaConstitution',
    SEARCH_DESCRIPTION: tr('searchDescription'),
    SEARCH_PLACEHOLDER: tr('searchPlaceholder'),
    EMPTY_PAGE_ICON: faLandmark,
    SEARCH_LOADING_MESSAGE: tr('searchLoadingMessage'),
    API_CALL: () => api.upload.getUploads(),
    DEFAULT_ERROR_MESSAGE: tr('defaultErrorMessage'),
    SELECT: (data) => data?.data
});
